// Requires: src/namespace.js

window.BOL.Caret = (function() {
	'use strict';

	function CallbackHandler() {
		var _self = this;
		var callbacks = [];

		_self.add = function add(callback) {
			if(typeof callback === 'function') {
				callbacks.push(callback);
			}
		};

		_self.remove = function remove(callback) {
			for(var i = 0; i < callbacks.length; i++) {
				if(callbacks[i] === callback) {
					callbacks.splice(i, 1);
				}
			}
		};

		_self.run = function run(data, prevData) {
			var i;
			var totalCallbacks = callbacks.length;

			if(totalCallbacks > 0) {
				for(i = 0; i < totalCallbacks; i++) {
					callbacks[i](data, prevData);
				}
			}
		};
	}

	function Component(options, theState) {

		var self = this;

		self.init = function init() {
			self.$nodes = document.querySelectorAll(options.selector);

			if(self.$nodes.length) {
				// Listen for state changes to the totals
				theState.subscribe(options.stateType, render);
			}
		}

		// Stub functions
		self.beforeComponentUpdates = function beforeComponentUpdates() {};
		self.afterComponentUpdated  = function afterComponentUpdated() {};

		function updateNode(i, newHTML) {
			self.beforeComponentUpdates(self.$nodes[i]);
			self.$nodes[i].innerHTML = newHTML;
			self.afterComponentUpdated(self.$nodes[i]);
		}

		function render(stateData) {
			var i;
			// Generate the new HTML for the totals
			var newHTML = options.template(stateData);

			// Replace the existing HTML
			for(i = 0; i < self.$nodes.length; i++) {
				updateNode(i, newHTML);
			};
		}
	}

	function State(baseState) {

		var callbacks = {};

		var STATE_TYPES = getStateTypes();

		function getStateTypes() {
			var types = {};

			for(var typeName in baseState) {
				if(baseState.hasOwnProperty(typeName)) {
					types[typeName] = typeName;
				}
			}

			return types;
		}

		function subscribe(type, callback) {
			throwIfNotValidType(type);
			ensureCallbackHandlerExists(type);

			callbacks[type].add(callback);
		}

		function set(type, newState) {
			var prevState;

			throwIfNotValidType(type);
			ensureCallbackHandlerExists(type);

			prevState   = baseState[type];
			baseState[type] = newState;

			callbacks[type].run(newState, prevState);
		}

		function get(type) {
			throwIfNotValidType(type);
			return baseState[type];
		}

		function ensureCallbackHandlerExists(type) {
			callbacks[type] = callbacks[type] || new CallbackHandler();
		}

		function throwIfNotValidType(type) {
			if(!isValidType(type)) {
				throw 'Type: "' + type + '" is not a valid type"';
			}
		}

		function isValidType(type) {
			// Needed for IE8 support
			for(var typeName in STATE_TYPES) {
				if(STATE_TYPES.hasOwnProperty(typeName) && STATE_TYPES[typeName] === type) {
					return true;
				}
			}
			return false;
		}

		return {
			subscribe: subscribe,
			set:       set,
			get:       get,
			type:      STATE_TYPES
		}
	}

	function createComponent(options) {
		return new Component(options, this.state);
	}

	function Caret(baseState) {
		this.state     = new State(baseState);
		this.component = {};

		this.component.create = createComponent.bind(this);
	}

	return Caret;

})();
